import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'animate.css';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material';
import './styles/index.scss'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssVarsProvider>
      <App />
    </CssVarsProvider>
  </React.StrictMode>
);